
import React from "react";

import {
  Percent,
  Hotel,
  PhoneCall,
  MessageCircle,
  Mail,
} from "lucide-react";

export default function TopBar() {
  return (
    <div className="w-full overflow-hidden bg-[#8B0000] text-white text-xs">
      <div className="mx-auto flex w-full max-w-screen-2xl overflow-hidden px-4 py-3">

        <div className="flex min-w-max animate-[marquee_25s_linear_infinite] items-center gap-12 whitespace-nowrap hover:[animation-play-state:paused]">

          {/* Exclusive Hotel Deals */}
          <span className="flex items-center gap-2 font-medium">
            <Percent
              size={15}
              strokeWidth={2}
              className="shrink-0 text-[#D7A74A]"
            />

            <span>Exclusive Hotel Deals:</span>

            <span className="font-semibold text-[#D7A74A]">
              Save up to 60%
            </span>

            <span>on Dubai Hotels</span>
          </span>

          {/* Dubai Beach Hotels */}
          <span className="flex items-center gap-2">
            <Hotel size={15} strokeWidth={2} className="shrink-0 text-[#D7A74A]" />
            <span>Luxury Beach Hotels Across Dubai</span>
          </span>

          {/* Best Rates */}
          <span className="flex items-center gap-2">
            <Hotel size={15} strokeWidth={2} className="shrink-0 text-[#D7A74A]" />
            <span>Best Rates on Selected Hotels</span>
          </span>

          {/* Easy Booking */}
          <span className="flex items-center gap-2">
            <Hotel size={15} strokeWidth={2} className="shrink-0 text-[#D7A74A]" />
            <span>Easy & Secure Hotel Booking</span>
          </span>

          {/* Email */}
          <a
            href="mailto:info@southtravels.com"
            className="group flex items-center gap-2 transition-all duration-300 hover:text-[#D7A74A]"
          >
            <Mail
              size={15}
              strokeWidth={2}
              className="shrink-0 transition-transform duration-300 group-hover:scale-110"
            />
            <span>info@southtravels.com</span>
          </a>

          {/* Phone */}
          <a
            href="tel:+971 4 447 3839 "
            className="group flex items-center gap-2 transition-all duration-300 hover:text-[#D7A74A]"
          >
            <PhoneCall
              size={15}
              strokeWidth={2}
              className="shrink-0 transition-transform duration-300 group-hover:scale-110"
            />
            <span>+971 4 447 3839 </span>
          </a>

          {/* WhatsApp */}
          <a
            href="https://wa.me/971502477593"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 transition-all duration-300 hover:text-[#D7A74A]"
          >
            <MessageCircle
              size={15}
              strokeWidth={2}
              className="shrink-0 transition-transform duration-300 group-hover:scale-110"
            />
            <span>Chat With Us on WhatsApp</span>
          </a>

        </div>
      </div>
    </div>
  );
}